import { ReactNode } from 'react';

import { Button, Text, Conditional, Container } from '@consumidor-positivo/aurora';
import { OfferEmptyState } from '@hub/components/OfferEmptyState';

import './styles.scss';
import { useDeviceSize } from '@libs/utils/hooks/useDeviceSize';
import classNames from 'classnames';

type FeaturedOfferTemplateProps = {
  title?: string;
  onClickMoreOffersBtn?: () => void;
  noOffer?: boolean;
  withIlustration?: boolean;
  children: ReactNode | ReactNode[];
};

export function FeaturedOfferTemplate({
  title,
  onClickMoreOffersBtn,
  noOffer = false,
  withIlustration = true,
  children,
}: FeaturedOfferTemplateProps) {
  const { isMobile } = useDeviceSize();

  const templateClasses = classNames('offers-featured', {
    'offers-featured--secondary-template': !withIlustration,
  });

  const buttonText = (isMobile ? 'Conhecer' : 'Ver') + ' mais ofertas';
  const buttonElement = (className?: string) => (
    <Button type="outlined" className={`offers-featured__button ${className}`} onClick={onClickMoreOffersBtn}>
      {buttonText}
    </Button>
  );

  return (
    <section className={templateClasses}>
      <Container>
        <div className="offers-featured__container">
          <Conditional
            condition={noOffer}
            renderIf={<OfferEmptyState />}
            renderElse={
              <>
                <div className="offers-featured__container-content">
                  <Conditional
                    condition={isMobile}
                    renderIf={
                      <>
                        {buttonElement('only-desk')}
                      </>
                    }
                  />
                  <Text as="h2" variant="heading-small" variantDesk="heading-medium" weight="bold">
                    {title}
                  </Text>
                  <Conditional
                    condition={withIlustration && !isMobile}
                    renderIf={
                      <>
                        {buttonElement('only-desk')}
                      </>
                    }
                  />
                </div>
                <div className="offers-featured__container-list">
                  {children}
                  <Text variant="body-small" weight="regular" color="secondary" className="offers-featured__container-list__disclaimer">
                    Sujeito à análise de crédito
                  </Text>
                  <Conditional condition={withIlustration} renderIf={buttonElement('only-mob')} renderElse={buttonElement()} />
                </div>
              </>
            }
          />
        </div>
      </Container>
    </section>
  );
}
